import {
  BeaconCategory,
  BeaconType,
  ProfilePlacement
} from "./chunk--chunk-XJAOVGY2.vbt.js";
import {
  DomTargeter,
  ErrorType,
  StorageStore,
  StorageType,
  require_cjs
} from "./chunk--chunk-GSFZ3OSC.vbt.js";
import {
  __commonJS,
  __toESM
} from "./chunk--chunk-Z7A6LSGX.vbt.js";

// node_modules/css.escape/css.escape.js
var require_css_escape = __commonJS({
  "node_modules/css.escape/css.escape.js"(exports, module) {
    (function(root, factory) {
      if (typeof exports == "object") {
        module.exports = factory(root);
      } else if (typeof define == "function" && define.amd) {
        define([], factory.bind(root, root));
      } else {
        factory(root);
      }
    })(typeof global != "undefined" ? global : exports, function(root) {
      if (root.CSS && root.CSS.escape) {
        return root.CSS.escape;
      }
      var cssEscape2 = function(value) {
        if (arguments.length == 0) {
          throw new TypeError("`CSS.escape` requires an argument.");
        }
        var string = String(value);
        var length = string.length;
        var index = -1;
        var codeUnit;
        var result = "";
        var firstCodeUnit = string.charCodeAt(0);
        while (++index < length) {
          codeUnit = string.charCodeAt(index);
          if (codeUnit == 0) {
            result += "\uFFFD";
            continue;
          }
          if (
            // If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
            // U+007F, […]
            codeUnit >= 1 && codeUnit <= 31 || codeUnit == 127 || // If the character is the first character and is in the range [0-9]
            // (U+0030 to U+0039), […]
            index == 0 && codeUnit >= 48 && codeUnit <= 57 || // If the character is the second character and is in the range [0-9]
            // (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
            index == 1 && codeUnit >= 48 && codeUnit <= 57 && firstCodeUnit == 45
          ) {
            result += "\\" + codeUnit.toString(16) + " ";
            continue;
          }
          if (
            // If the character is the first character and is a `-` (U+002D), and
            // there is no second character, […]
            index == 0 && length == 1 && codeUnit == 45
          ) {
            result += "\\" + string.charAt(index);
            continue;
          }
          if (codeUnit >= 128 || codeUnit == 45 || codeUnit == 95 || codeUnit >= 48 && codeUnit <= 57 || codeUnit >= 65 && codeUnit <= 90 || codeUnit >= 97 && codeUnit <= 122) {
            result += string.charAt(index);
            continue;
          }
          result += "\\" + string.charAt(index);
        }
        return result;
      };
      if (!root.CSS) {
        root.CSS = {};
      }
      root.CSS.escape = cssEscape2;
      return cssEscape2;
    });
  }
});

// node_modules/seamless-immutable/seamless-immutable.development.js
var require_seamless_immutable_development = __commonJS({
  "node_modules/seamless-immutable/seamless-immutable.development.js"(exports, module) {
    (function() {
      "use strict";
      function immutableInit(config) {
        var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element");
        var REACT_ELEMENT_TYPE_FALLBACK = 60103;
        var globalConfig = {
          use_static: false
        };
        if (isObject(config)) {
          if (config.use_static !== void 0) {
            globalConfig.use_static = Boolean(config.use_static);
          }
        }
        function isObject(data) {
          return typeof data === "object" && !Array.isArray(data) && data !== null;
        }
        function instantiateEmptyObject(obj) {
          var prototype = Object.getPrototypeOf(obj);
          if (!prototype) {
            return {};
          } else {
            return Object.create(prototype);
          }
        }
        function addPropertyTo(target, methodName, value) {
          Object.defineProperty(target, methodName, {
            enumerable: false,
            configurable: false,
            writable: false,
            value
          });
        }
        function banProperty(target, methodName) {
          addPropertyTo(target, methodName, function() {
            throw new ImmutableError("The " + methodName + " method cannot be invoked on an Immutable data structure.");
          });
        }
        var immutabilityTag = "__immutable_invariants_hold";
        function addImmutabilityTag(target) {
          addPropertyTo(target, immutabilityTag, true);
        }
        function isImmutable(target) {
          if (typeof target === "object") {
            return target === null || Boolean(
              Object.getOwnPropertyDescriptor(target, immutabilityTag)
            );
          } else {
            return true;
          }
        }
        function isEqual(a, b) {
          return a === b || a !== a && b !== b;
        }
        function isMergableObject(target) {
          return target !== null && typeof target === "object" && !Array.isArray(target) && !(target instanceof Date);
        }
        var mutatingObjectMethods = [
          "setPrototypeOf"
        ];
        var nonMutatingObjectMethods = [
          "keys"
        ];
        var mutatingArrayMethods = mutatingObjectMethods.concat([
          "push",
          "pop",
          "sort",
          "splice",
          "shift",
          "unshift",
          "reverse"
        ]);
        var nonMutatingArrayMethods = nonMutatingObjectMethods.concat([
          "map",
          "filter",
          "slice",
          "concat",
          "reduce",
          "reduceRight"
        ]);
        var mutatingDateMethods = mutatingObjectMethods.concat([
          "setDate",
          "setFullYear",
          "setHours",
          "setMilliseconds",
          "setMinutes",
          "setMonth",
          "setSeconds",
          "setTime",
          "setUTCDate",
          "setUTCFullYear",
          "setUTCHours",
          "setUTCMilliseconds",
          "setUTCMinutes",
          "setUTCMonth",
          "setUTCSeconds",
          "setYear"
        ]);
        function ImmutableError(message) {
          this.name = "MyError";
          this.message = message;
          this.stack = new Error().stack;
        }
        ImmutableError.prototype = new Error();
        ImmutableError.prototype.constructor = Error;
        function makeImmutable(obj, bannedMethods) {
          addImmutabilityTag(obj);
          if (true) {
            for (var index in bannedMethods) {
              if (bannedMethods.hasOwnProperty(index)) {
                banProperty(obj, bannedMethods[index]);
              }
            }
            Object.freeze(obj);
          }
          return obj;
        }
        function makeMethodReturnImmutable(obj, methodName) {
          var currentMethod = obj[methodName];
          addPropertyTo(obj, methodName, function() {
            return Immutable3(currentMethod.apply(obj, arguments));
          });
        }
        function arraySet(idx, value, config2) {
          var deep = config2 && config2.deep;
          if (idx in this) {
            if (deep && this[idx] !== value && isMergableObject(value) && isMergableObject(this[idx])) {
              value = Immutable3.merge(this[idx], value, { deep: true, mode: "replace" });
            }
            if (isEqual(this[idx], value)) {
              return this;
            }
          }
          var mutable = asMutableArray.call(this);
          mutable[idx] = Immutable3(value);
          return makeImmutableArray(mutable);
        }
        var immutableEmptyArray = Immutable3([]);
        function arraySetIn(pth, value, config2) {
          var head = pth[0];
          if (pth.length === 1) {
            return arraySet.call(this, head, value, config2);
          } else {
            var tail = pth.slice(1);
            var thisHead = this[head];
            var newValue;
            if (typeof thisHead === "object" && thisHead !== null) {
              newValue = Immutable3.setIn(thisHead, tail, value);
            } else {
              var nextHead = tail[0];
              if (nextHead !== "" && isFinite(nextHead)) {
                newValue = arraySetIn.call(immutableEmptyArray, tail, value);
              } else {
                newValue = objectSetIn.call(immutableEmptyObject, tail, value);
              }
            }
            if (head in this && thisHead === newValue) {
              return this;
            }
            var mutable = asMutableArray.call(this);
            mutable[head] = newValue;
            return makeImmutableArray(mutable);
          }
        }
        function makeImmutableArray(array) {
          for (var index in nonMutatingArrayMethods) {
            if (nonMutatingArrayMethods.hasOwnProperty(index)) {
              var methodName = nonMutatingArrayMethods[index];
              makeMethodReturnImmutable(array, methodName);
            }
          }
          if (!globalConfig.use_static) {
            addPropertyTo(array, "flatMap", flatMap);
            addPropertyTo(array, "asObject", asObject);
            addPropertyTo(array, "asMutable", asMutableArray);
            addPropertyTo(array, "set", arraySet);
            addPropertyTo(array, "setIn", arraySetIn);
            addPropertyTo(array, "update", update);
            addPropertyTo(array, "updateIn", updateIn);
            addPropertyTo(array, "getIn", getIn);
          }
          for (var i = 0, length = array.length; i < length; i++) {
            array[i] = Immutable3(array[i]);
          }
          return makeImmutable(array, mutatingArrayMethods);
        }
        function makeImmutableDate(date) {
          if (!globalConfig.use_static) {
            addPropertyTo(date, "asMutable", asMutableDate);
          }
          return makeImmutable(date, mutatingDateMethods);
        }
        function asMutableDate() {
          return new Date(this.getTime());
        }
        function flatMap(iterator) {
          if (arguments.length === 0) {
            return this;
          }
          var result = [], length = this.length, index;
          for (index = 0; index < length; index++) {
            var iteratorResult = iterator(this[index], index, this);
            if (Array.isArray(iteratorResult)) {
              result.push.apply(result, iteratorResult);
            } else {
              result.push(iteratorResult);
            }
          }
          return makeImmutableArray(result);
        }
        function without(remove) {
          if (typeof remove === "undefined" && arguments.length === 0) {
            return this;
          }
          if (typeof remove !== "function") {
            var keysToRemoveArray = Array.isArray(remove) ? remove.slice() : Array.prototype.slice.call(arguments);
            keysToRemoveArray.forEach(function(el, idx, arr) {
              if (typeof el === "number") {
                arr[idx] = el.toString();
              }
            });
            remove = function(val, key2) {
              return keysToRemoveArray.indexOf(key2) !== -1;
            };
          }
          var result = instantiateEmptyObject(this);
          for (var key in this) {
            if (this.hasOwnProperty(key) && remove(this[key], key) === false) {
              result[key] = this[key];
            }
          }
          return makeImmutableObject(result);
        }
        function asMutableArray(opts) {
          var result = [], i, length;
          if (opts && opts.deep) {
            for (i = 0, length = this.length; i < length; i++) {
              result.push(asDeepMutable(this[i]));
            }
          } else {
            for (i = 0, length = this.length; i < length; i++) {
              result.push(this[i]);
            }
          }
          return result;
        }
        function asObject(iterator) {
          if (typeof iterator !== "function") {
            iterator = function(value2) {
              return value2;
            };
          }
          var result = {}, length = this.length, index;
          for (index = 0; index < length; index++) {
            var pair = iterator(this[index], index, this), key = pair[0], value = pair[1];
            result[key] = value;
          }
          return makeImmutableObject(result);
        }
        function asDeepMutable(obj) {
          if (!obj || typeof obj !== "object" || !Object.getOwnPropertyDescriptor(obj, immutabilityTag) || obj instanceof Date) {
            return obj;
          }
          return Immutable3.asMutable(obj, { deep: true });
        }
        function quickCopy(src, dest) {
          for (var key in src) {
            if (Object.getOwnPropertyDescriptor(src, key)) {
              dest[key] = src[key];
            }
          }
          return dest;
        }
        function merge(other, config2) {
          if (arguments.length === 0) {
            return this;
          }
          if (other === null || typeof other !== "object") {
            throw new TypeError("Immutable#merge can only be invoked with objects or arrays, not " + JSON.stringify(other));
          }
          var receivedArray = Array.isArray(other), deep = config2 && config2.deep, mode = config2 && config2.mode || "merge", merger = config2 && config2.merger, result;
          function addToResult(currentObj, otherObj, key2) {
            var immutableValue = Immutable3(otherObj[key2]);
            var mergerResult = merger && merger(currentObj[key2], immutableValue, config2);
            var currentValue = currentObj[key2];
            if (result !== void 0 || mergerResult !== void 0 || !currentObj.hasOwnProperty(key2) || !isEqual(immutableValue, currentValue)) {
              var newValue;
              if (mergerResult !== void 0) {
                newValue = mergerResult;
              } else if (deep && isMergableObject(currentValue) && isMergableObject(immutableValue)) {
                newValue = Immutable3.merge(currentValue, immutableValue, config2);
              } else {
                newValue = immutableValue;
              }
              if (!isEqual(currentValue, newValue) || !currentObj.hasOwnProperty(key2)) {
                if (result === void 0) {
                  result = quickCopy(currentObj, instantiateEmptyObject(currentObj));
                }
                result[key2] = newValue;
              }
            }
          }
          function clearDroppedKeys(currentObj, otherObj) {
            for (var key2 in currentObj) {
              if (!otherObj.hasOwnProperty(key2)) {
                if (result === void 0) {
                  result = quickCopy(currentObj, instantiateEmptyObject(currentObj));
                }
                delete result[key2];
              }
            }
          }
          var key;
          if (!receivedArray) {
            for (key in other) {
              if (Object.getOwnPropertyDescriptor(other, key)) {
                addToResult(this, other, key);
              }
            }
            if (mode === "replace") {
              clearDroppedKeys(this, other);
            }
          } else {
            for (var index = 0, length = other.length; index < length; index++) {
              var otherFromArray = other[index];
              for (key in otherFromArray) {
                if (otherFromArray.hasOwnProperty(key)) {
                  addToResult(result !== void 0 ? result : this, otherFromArray, key);
                }
              }
            }
          }
          if (result === void 0) {
            return this;
          } else {
            return makeImmutableObject(result);
          }
        }
        function objectReplace(value, config2) {
          var deep = config2 && config2.deep;
          if (arguments.length === 0) {
            return this;
          }
          if (value === null || typeof value !== "object") {
            throw new TypeError("Immutable#replace can only be invoked with objects or arrays, not " + JSON.stringify(value));
          }
          return Immutable3.merge(this, value, { deep, mode: "replace" });
        }
        var immutableEmptyObject = Immutable3({});
        function objectSetIn(path, value, config2) {
          if (!Array.isArray(path) || path.length === 0) {
            throw new TypeError('The first argument to Immutable#setIn must be an array containing at least one "key" string.');
          }
          var head = path[0];
          if (path.length === 1) {
            return objectSet.call(this, head, value, config2);
          }
          var tail = path.slice(1);
          var newValue;
          var thisHead = this[head];
          if (this.hasOwnProperty(head) && typeof thisHead === "object" && thisHead !== null) {
            newValue = Immutable3.setIn(thisHead, tail, value);
          } else {
            newValue = objectSetIn.call(immutableEmptyObject, tail, value);
          }
          if (this.hasOwnProperty(head) && thisHead === newValue) {
            return this;
          }
          var mutable = quickCopy(this, instantiateEmptyObject(this));
          mutable[head] = newValue;
          return makeImmutableObject(mutable);
        }
        function objectSet(property, value, config2) {
          var deep = config2 && config2.deep;
          if (this.hasOwnProperty(property)) {
            if (deep && this[property] !== value && isMergableObject(value) && isMergableObject(this[property])) {
              value = Immutable3.merge(this[property], value, { deep: true, mode: "replace" });
            }
            if (isEqual(this[property], value)) {
              return this;
            }
          }
          var mutable = quickCopy(this, instantiateEmptyObject(this));
          mutable[property] = Immutable3(value);
          return makeImmutableObject(mutable);
        }
        function update(property, updater) {
          var restArgs = Array.prototype.slice.call(arguments, 2);
          var initialVal = this[property];
          return Immutable3.set(this, property, updater.apply(initialVal, [initialVal].concat(restArgs)));
        }
        function getInPath(obj, path) {
          for (var i = 0, l = path.length; obj != null && i < l; i++) {
            obj = obj[path[i]];
          }
          return i && i == l ? obj : void 0;
        }
        function updateIn(path, updater) {
          var restArgs = Array.prototype.slice.call(arguments, 2);
          var initialVal = getInPath(this, path);
          return Immutable3.setIn(this, path, updater.apply(initialVal, [initialVal].concat(restArgs)));
        }
        function getIn(path, defaultValue) {
          var value = getInPath(this, path);
          return value === void 0 ? defaultValue : value;
        }
        function asMutableObject(opts) {
          var result = instantiateEmptyObject(this), key;
          if (opts && opts.deep) {
            for (key in this) {
              if (this.hasOwnProperty(key)) {
                result[key] = asDeepMutable(this[key]);
              }
            }
          } else {
            for (key in this) {
              if (this.hasOwnProperty(key)) {
                result[key] = this[key];
              }
            }
          }
          return result;
        }
        function instantiatePlainObject() {
          return {};
        }
        function makeImmutableObject(obj) {
          if (!globalConfig.use_static) {
            addPropertyTo(obj, "merge", merge);
            addPropertyTo(obj, "replace", objectReplace);
            addPropertyTo(obj, "without", without);
            addPropertyTo(obj, "asMutable", asMutableObject);
            addPropertyTo(obj, "set", objectSet);
            addPropertyTo(obj, "setIn", objectSetIn);
            addPropertyTo(obj, "update", update);
            addPropertyTo(obj, "updateIn", updateIn);
            addPropertyTo(obj, "getIn", getIn);
          }
          return makeImmutable(obj, mutatingObjectMethods);
        }
        function isReactElement(obj) {
          return typeof obj === "object" && obj !== null && (obj.$$typeof === REACT_ELEMENT_TYPE_FALLBACK || obj.$$typeof === REACT_ELEMENT_TYPE);
        }
        function isFileObject(obj) {
          return typeof File !== "undefined" && obj instanceof File;
        }
        function isBlobObject(obj) {
          return typeof Blob !== "undefined" && obj instanceof Blob;
        }
        function isPromise(obj) {
          return typeof obj === "object" && typeof obj.then === "function";
        }
        function isError(obj) {
          return obj instanceof Error;
        }
        function Immutable3(obj, options, stackRemaining) {
          if (isImmutable(obj) || isReactElement(obj) || isFileObject(obj) || isBlobObject(obj) || isError(obj)) {
            return obj;
          } else if (isPromise(obj)) {
            return obj.then(Immutable3);
          } else if (Array.isArray(obj)) {
            return makeImmutableArray(obj.slice());
          } else if (obj instanceof Date) {
            return makeImmutableDate(new Date(obj.getTime()));
          } else {
            var prototype = options && options.prototype;
            var instantiateEmptyObject2 = !prototype || prototype === Object.prototype ? instantiatePlainObject : function() {
              return Object.create(prototype);
            };
            var clone = instantiateEmptyObject2();
            if (true) {
              if (stackRemaining == null) {
                stackRemaining = 64;
              }
              if (stackRemaining <= 0) {
                throw new ImmutableError("Attempt to construct Immutable from a deeply nested object was detected. Have you tried to wrap an object with circular references (e.g. React element)? See https://github.com/rtfeldman/seamless-immutable/wiki/Deeply-nested-object-was-detected for details.");
              }
              stackRemaining -= 1;
            }
            for (var key in obj) {
              if (Object.getOwnPropertyDescriptor(obj, key)) {
                clone[key] = Immutable3(obj[key], void 0, stackRemaining);
              }
            }
            return makeImmutableObject(clone);
          }
        }
        function toStatic(fn) {
          function staticWrapper() {
            var args = [].slice.call(arguments);
            var self = args.shift();
            return fn.apply(self, args);
          }
          return staticWrapper;
        }
        function toStaticObjectOrArray(fnObject, fnArray) {
          function staticWrapper() {
            var args = [].slice.call(arguments);
            var self = args.shift();
            if (Array.isArray(self)) {
              return fnArray.apply(self, args);
            } else {
              return fnObject.apply(self, args);
            }
          }
          return staticWrapper;
        }
        function toStaticObjectOrDateOrArray(fnObject, fnArray, fnDate) {
          function staticWrapper() {
            var args = [].slice.call(arguments);
            var self = args.shift();
            if (Array.isArray(self)) {
              return fnArray.apply(self, args);
            } else if (self instanceof Date) {
              return fnDate.apply(self, args);
            } else {
              return fnObject.apply(self, args);
            }
          }
          return staticWrapper;
        }
        Immutable3.from = Immutable3;
        Immutable3.isImmutable = isImmutable;
        Immutable3.ImmutableError = ImmutableError;
        Immutable3.merge = toStatic(merge);
        Immutable3.replace = toStatic(objectReplace);
        Immutable3.without = toStatic(without);
        Immutable3.asMutable = toStaticObjectOrDateOrArray(asMutableObject, asMutableArray, asMutableDate);
        Immutable3.set = toStaticObjectOrArray(objectSet, arraySet);
        Immutable3.setIn = toStaticObjectOrArray(objectSetIn, arraySetIn);
        Immutable3.update = toStatic(update);
        Immutable3.updateIn = toStatic(updateIn);
        Immutable3.getIn = toStatic(getIn);
        Immutable3.flatMap = toStatic(flatMap);
        Immutable3.asObject = toStatic(asObject);
        if (!globalConfig.use_static) {
          Immutable3.static = immutableInit({
            use_static: true
          });
        }
        Object.freeze(Immutable3);
        return Immutable3;
      }
      var Immutable2 = immutableInit();
      if (typeof define === "function" && define.amd) {
        define(function() {
          return Immutable2;
        });
      } else if (typeof module === "object") {
        module.exports = Immutable2;
      } else if (typeof exports === "object") {
        exports.Immutable = Immutable2;
      } else if (typeof window === "object") {
        window.Immutable = Immutable2;
      } else if (typeof global === "object") {
        global.Immutable = Immutable2;
      }
    })();
  }
});

// node_modules/@searchspring/snap-controller/dist/esm/Finder/FinderController.js
var import_deepmerge = __toESM(require_cjs());

// node_modules/@searchspring/snap-controller/dist/esm/Abstract/AbstractController.js
var AbstractController = class {
  constructor(config, { client, store, urlManager, eventManager, profiler, logger, tracker }, context = {}) {
    this.type = "abstract";
    this.targeters = {};
    this._initialized = false;
    this.handleError = (err, details) => {
      let event;
      if (err instanceof ErrorEvent) {
        event = err;
      } else if (err instanceof Error) {
        event = new ErrorEvent("error", {
          error: err,
          message: err.message
        });
      } else if (typeof err === "string" || typeof err == "number") {
        event = new ErrorEvent("error", {
          error: new Error(err.toString())
        });
      } else if (typeof err === "object" && Object.keys(err).length) {
        try {
          event = new ErrorEvent("error", {
            error: new Error(JSON.stringify(err))
          });
        } catch (e) {
        }
      }
      if (event) {
        const { filename, colno, lineno, error: { stack }, message, timeStamp } = event;
        const beaconPayload = {
          filename,
          stack,
          message,
          colno,
          lineno,
          errortimestamp: timeStamp,
          details,
          context: {
            controller: {
              id: this.id,
              type: this.type
            }
          }
        };
        this.tracker.track.error(beaconPayload);
        this.eventManager.fire("error", { controller: this, error: err });
      }
    };
    if (typeof config != "object" || typeof config.id != "string" || !config.id.match(/^[a-zA-Z0-9_-]*$/)) {
      throw new Error(`Invalid config passed to controller. The "id" attribute must be an alphanumeric string.`);
    }
    if (typeof client != "object" || typeof client.search != "function") {
      throw new Error(`Invalid service 'client' passed to controller. Missing "search" function.`);
    }
    if (typeof store != "object" || typeof store.update != "function") {
      throw new Error(`Invalid service 'store' passed to controller. Missing "update" function.`);
    }
    if (typeof urlManager != "object" || typeof urlManager.subscribe != "function") {
      throw new Error(`Invalid service 'urlManager' passed to controller. Missing "subscribe" function.`);
    }
    if (typeof eventManager != "object" || typeof eventManager.on != "function") {
      throw new Error(`Invalid service 'eventManager' passed to controller. Missing "on" function.`);
    }
    if (typeof eventManager != "object" || typeof eventManager.fire != "function") {
      throw new Error(`Invalid service 'eventManager' passed to controller. Missing "fire" function.`);
    }
    if (typeof profiler != "object" || typeof profiler.setNamespace != "function") {
      throw new Error(`Invalid service 'profiler' passed to controller. Missing "setNamespace" function.`);
    }
    if (typeof profiler != "object" || typeof profiler.create != "function") {
      throw new Error(`Invalid service 'profiler' passed to controller. Missing "create" function.`);
    }
    if (typeof logger != "object" || typeof logger.dev != "function") {
      throw new Error(`Invalid service 'logger' passed to controller. Missing "dev" function.`);
    }
    if (typeof tracker != "object" || typeof tracker.track != "object") {
      throw new Error(`Invalid service 'tracker' passed to controller. Missing "track" object.`);
    }
    this.id = config.id;
    this.config = config;
    this.client = client;
    this.store = store;
    this.urlManager = urlManager;
    this.eventManager = eventManager;
    this.profiler = profiler;
    this.log = logger;
    this.tracker = tracker;
    this.context = context;
    this.log.setNamespace(this.config.id);
    this.profiler.setNamespace(this.config.id);
  }
  get initialized() {
    return this._initialized;
  }
  createTargeter(target, onTarget, document2) {
    return this.addTargeter(new DomTargeter([target], onTarget, document2));
  }
  addTargeter(target) {
    const firstTarget = target.getTargets()[0];
    const targetName = firstTarget?.name ?? firstTarget?.selector;
    if (targetName && !this.targeters[targetName]) {
      this.targeters[targetName] = target;
      return target;
    }
  }
  async init() {
    if (this._initialized) {
      this.log.warn(`'init' middleware recalled`);
    }
    const initProfile = this.profiler.create({ type: "event", name: "init", context: this.config }).start();
    try {
      try {
        await this.eventManager.fire("init", {
          controller: this
        });
      } catch (err) {
        if (err?.message == "cancelled") {
          this.log.warn(`'init' middleware cancelled`);
        } else {
          this.log.error(`error in 'init' middleware`);
          throw err;
        }
      }
    } catch (err) {
      if (err) {
        console.error(err);
        this.handleError(err);
      }
    }
    if (!this._initialized) {
      this.urlManager.subscribe((prev, next) => {
        try {
          const prevString = JSON.stringify(prev);
          const nextString = JSON.stringify(next);
          if (prevString !== nextString) {
            this.search();
          }
        } catch (err) {
          this.log.error("URL state is invalid", err);
        }
      });
      this._initialized = true;
    }
    initProfile.stop();
    this.log.profile(initProfile);
  }
  retarget() {
    Object.keys(this.targeters).forEach((target) => {
      this.targeters[target].retarget();
    });
  }
  async plugin(func, ...args) {
    await func(this, ...args);
  }
  on(event, ...func) {
    this.eventManager.on(event, ...func);
  }
  use(attachments) {
    if (attachments?.plugins) {
      try {
        if (!Array.isArray(attachments?.plugins)) {
          throw "invalid format";
        }
        attachments?.plugins.forEach((plugin) => {
          if (!Array.isArray(plugin)) {
            throw "invalid format";
          }
          const [func, ...args] = plugin;
          this.plugin(func, ...args);
        });
      } catch (err) {
        this.log.warn("plugins not attached - use format [func, ...args?][]");
      }
    }
    if (attachments?.middleware) {
      Object.keys(attachments.middleware).forEach((eventName) => {
        const eventMiddleware = attachments.middleware[eventName];
        let middlewareArray;
        if (Array.isArray(eventMiddleware)) {
          middlewareArray = eventMiddleware;
        } else {
          middlewareArray = [eventMiddleware];
        }
        middlewareArray.forEach((middleware) => {
          this.on(eventName, middleware);
        });
      });
    }
  }
};

// node_modules/@searchspring/snap-controller/dist/esm/utils/getParams.js
function getSearchParams(state) {
  const params = {};
  if (state.tag) {
    params.merchandising = params.merchandising || {};
    params.merchandising.landingPage = state.tag;
  }
  if (state.query) {
    params.search = params.search || {};
    params.search.query = params.search.query || {};
    params.search.query.string = state.query;
  }
  if (state.rq) {
    params.search = params.search || {};
    params.search.subQuery = state.rq;
  }
  if (state.oq) {
    params.search = params.search || {};
    params.search.originalQuery = state.oq;
  }
  if (state.fallbackQuery) {
    params.search = params.search || {};
    params.search.fallbackQuery = state.fallbackQuery;
  }
  if (state.page) {
    params.pagination = params.pagination || {};
    params.pagination.page = state.page;
  }
  if (state.pageSize) {
    params.pagination = params.pagination || {};
    params.pagination.pageSize = state.pageSize;
  }
  if (state.sort) {
    params.sorts = params.sorts || [];
    const sorts = Array.isArray(state.sort) ? state.sort : [state.sort];
    const sort = sorts[0];
    if (sort && sort.field && sort.direction) {
      params.sorts.push({
        field: sort.field,
        direction: sort.direction
      });
    }
  }
  if (state.filter) {
    params.filters = params.filters || [];
    Object.keys(state.filter).forEach((field) => {
      if (typeof field != "string") {
        return;
      }
      const filter = state.filter[field];
      const values = Array.isArray(filter) ? filter : [filter];
      values.forEach((value) => {
        if (typeof value != "object") {
          params.filters.push({
            type: "value",
            field,
            value
          });
        } else if (typeof value.low != "undefined" && typeof value.high != "undefined") {
          params.filters.push({
            type: "range",
            field,
            value
          });
        }
      });
    });
  }
  return params;
}

// node_modules/@searchspring/snap-controller/dist/esm/types.js
var ControllerTypes;
(function(ControllerTypes2) {
  ControllerTypes2["search"] = "search";
  ControllerTypes2["autocomplete"] = "autocomplete";
  ControllerTypes2["finder"] = "finder";
  ControllerTypes2["recommendation"] = "recommendation";
})(ControllerTypes || (ControllerTypes = {}));

// node_modules/@searchspring/snap-controller/dist/esm/Finder/FinderController.js
var defaultConfig = {
  id: "finder",
  globals: {
    pagination: {
      pageSize: 0
    }
  },
  fields: [],
  persist: {
    enabled: false,
    lockSelections: true,
    expiration: 0
  }
};
var FinderController = class extends AbstractController {
  constructor(config, { client, store, urlManager, eventManager, profiler, logger, tracker }, context) {
    super(config, { client, store, urlManager, eventManager, profiler, logger, tracker }, context);
    this.type = ControllerTypes.finder;
    this.find = async () => {
      await this.store.save();
      try {
        await this.eventManager.fire("beforeFind", {
          controller: this
        });
      } catch (err) {
        if (err?.message == "cancelled") {
          this.log.warn(`'beforeFind' middleware cancelled`);
        } else {
          this.log.error(`error in 'beforeFind' middleware`);
          this.log.error(err);
        }
      }
    };
    this.reset = () => {
      this.store.reset();
      this.urlManager.remove("filter").go();
      this.store.setService("urlManager", this.urlManager);
    };
    this.search = async () => {
      if (!this.initialized) {
        await this.init();
      }
      if (this.store.state.persisted) {
        return;
      }
      const params = this.params;
      try {
        try {
          await this.eventManager.fire("beforeSearch", {
            controller: this,
            request: params
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'beforeSearch' middleware cancelled`);
            return;
          } else {
            this.log.error(`error in 'beforeSearch' middleware`);
            throw err;
          }
        }
        const searchProfile = this.profiler.create({ type: "event", name: "search", context: params }).start();
        const [meta, response] = await this.client.finder(params);
        if (!response.meta) {
          response.meta = meta;
        }
        searchProfile.stop();
        this.log.profile(searchProfile);
        const afterSearchProfile = this.profiler.create({ type: "event", name: "afterSearch", context: params }).start();
        try {
          await this.eventManager.fire("afterSearch", {
            controller: this,
            request: params,
            response
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'afterSearch' middleware cancelled`);
            afterSearchProfile.stop();
            return;
          } else {
            this.log.error(`error in 'afterSearch' middleware`);
            throw err;
          }
        }
        afterSearchProfile.stop();
        this.log.profile(afterSearchProfile);
        this.store.update(response);
        const afterStoreProfile = this.profiler.create({ type: "event", name: "afterStore", context: params }).start();
        try {
          await this.eventManager.fire("afterStore", {
            controller: this,
            request: params,
            response
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'afterStore' middleware cancelled`);
            afterStoreProfile.stop();
            return;
          } else {
            this.log.error(`error in 'afterStore' middleware`);
            throw err;
          }
        }
        afterStoreProfile.stop();
        this.log.profile(afterStoreProfile);
      } catch (err) {
        if (err) {
          if (err.err && err.fetchDetails) {
            switch (err.fetchDetails.status) {
              case 429: {
                this.store.error = {
                  code: 429,
                  type: ErrorType.WARNING,
                  message: "Too many requests try again later"
                };
                break;
              }
              case 500: {
                this.store.error = {
                  code: 500,
                  type: ErrorType.ERROR,
                  message: "Invalid Search Request or Service Unavailable"
                };
                break;
              }
              default: {
                this.store.error = {
                  type: ErrorType.ERROR,
                  message: err.err.message
                };
                break;
              }
            }
            this.log.error(this.store.error);
            this.handleError(err.err, err.fetchDetails);
          } else {
            this.store.error = {
              type: ErrorType.ERROR,
              message: `Something went wrong... - ${err}`
            };
            this.log.error(err);
            this.handleError(err);
          }
          this.store.loading = false;
        }
      }
    };
    this.config = (0, import_deepmerge.default)(defaultConfig, this.config);
    this.store.setConfig(this.config);
    if (this.config.url) {
      this.urlManager = this.urlManager.withConfig((translatorConfig) => {
        return {
          ...translatorConfig,
          urlRoot: this.config.url
        };
      });
    }
    this.eventManager.on("beforeSearch", async (finder, next) => {
      finder.controller.store.loading = true;
      await next();
    });
    this.eventManager.on("afterSearch", async (finder, next) => {
      await next();
      finder.controller.store.loading = false;
    });
    this.eventManager.on("beforeFind", async (finder, next) => {
      await next();
      window.location.href = this.urlManager.href;
    });
    this.use(this.config);
    this.store.loadPersisted();
  }
  get params() {
    const urlState = this.urlManager.state;
    const userId = this.tracker.getUserId();
    const sessionId = this.tracker.getContext().sessionId;
    const pageLoadId = this.tracker.getContext().pageLoadId;
    const tracking = {};
    if (userId) {
      tracking.userId = userId;
    }
    if (sessionId) {
      tracking.sessionId = sessionId;
    }
    if (pageLoadId) {
      tracking.pageLoadId = pageLoadId;
    }
    tracking.domain = window.location.href;
    const defaultParams = {
      facets: {
        include: this.config.fields.map((fieldConfig) => fieldConfig.field),
        autoDrillDown: false
      },
      tracking
    };
    const params = (0, import_deepmerge.default)({ ...getSearchParams(urlState) }, (0, import_deepmerge.default)(defaultParams, this.config.globals));
    return params;
  }
};

// node_modules/@searchspring/snap-controller/dist/esm/Search/SearchController.js
var import_deepmerge2 = __toESM(require_cjs());
var import_css = __toESM(require_css_escape());
var API_LIMIT = 500;
var defaultConfig2 = {
  id: "search",
  globals: {},
  settings: {
    redirects: {
      merchandising: true,
      singleResult: true
    },
    facets: {
      trim: true,
      pinFiltered: true,
      storeRange: true,
      autoOpenActive: true
    }
  }
};
var SearchController = class extends AbstractController {
  constructor(config, { client, store, urlManager, eventManager, profiler, logger, tracker }, context) {
    super(config, { client, store, urlManager, eventManager, profiler, logger, tracker }, context);
    this.type = ControllerTypes.search;
    this.previousResults = [];
    this.track = {
      product: {
        click: (e, result) => {
          const target = e.target;
          const resultHref = result.mappings.core?.url;
          const elemHref = target?.getAttribute("href");
          const storedHref = elemHref?.indexOf(resultHref) != -1 ? resultHref : elemHref || resultHref;
          const scrollMap = {};
          const selector = generateHrefSelector(target, storedHref);
          const domRect = selector ? document?.querySelector(selector)?.getBoundingClientRect() : void 0;
          if (selector || storedHref || domRect) {
            try {
              const stringyParams = JSON.parse(this.storage.get("lastStringyParams"));
              const storableRequestParams = getStorableRequestParams(stringyParams);
              const storableStringyParams = JSON.stringify(storableRequestParams);
              scrollMap[storableStringyParams] = { domRect, href: storedHref, selector };
            } catch (err) {
              this.log.warn("Failed to save scollMap!", err);
            }
          }
          this.storage.set("scrollMap", scrollMap);
          const { intellisuggestData, intellisuggestSignature } = result.attributes;
          const event = this.tracker.track.product.click({
            intellisuggestData,
            intellisuggestSignature,
            href: elemHref || resultHref
          });
          this.eventManager.fire("track.product.click", { controller: this, event: e, result, trackEvent: event });
          return event;
        }
      }
    };
    this.search = async () => {
      if (!this.initialized) {
        await this.init();
      }
      const params = this.params;
      if (this.params.search?.query?.string && this.params.search?.query?.string.length) {
        this.store.history.save(this.params.search.query.string);
      }
      try {
        try {
          await this.eventManager.fire("beforeSearch", {
            controller: this,
            request: params
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'beforeSearch' middleware cancelled`);
            return;
          } else {
            this.log.error(`error in 'beforeSearch' middleware`);
            throw err;
          }
        }
        const stringyParams = JSON.stringify(params);
        const prevStringyParams = this.storage.get("lastStringyParams");
        if (stringyParams == prevStringyParams) {
          return;
        }
        const searchProfile = this.profiler.create({ type: "event", name: "search", context: params }).start();
        let meta;
        let response;
        if (this.config.settings?.infinite && params.pagination?.page && params.pagination.page > 1) {
          const preventBackfill = this.config.settings.infinite?.backfill && !this.store.results.length && params.pagination.page > this.config.settings.infinite.backfill;
          const dontBackfill = !this.config.settings.infinite?.backfill && !this.store.results.length;
          if (preventBackfill || dontBackfill) {
            this.storage.set("scrollMap", {});
            this.urlManager.set("page", 1).go();
            return;
          }
          const backfills = [];
          let pageSize = params.pagination?.pageSize || this.store.pagination.pageSize || this.store.pagination.defaultPageSize;
          if (this.config.settings?.infinite.backfill && !this.previousResults.length) {
            if (!pageSize) {
              const meta2 = await this.client.meta();
              pageSize = meta2.pagination?.defaultPageSize;
            }
            pageSize = pageSize > API_LIMIT ? API_LIMIT : pageSize;
            const pagesNeeded = params.pagination?.page && params.pagination?.page > this.config.settings?.infinite.backfill ? this.config.settings?.infinite.backfill : params.pagination?.page;
            const { size: backFillPageSize, pages: backFillPages } = backFillSize(pagesNeeded, pageSize);
            for (let i = 1; i <= backFillPages; i++) {
              const backfillParams = (0, import_deepmerge2.default)({ ...params }, { pagination: { pageSize: backFillPageSize, page: i } });
              backfills.push(this.client.search(backfillParams));
            }
          }
          if (backfills && backfills.length) {
            const backfillResults = [];
            const backfillResponses = await Promise.all(backfills);
            backfillResponses.map(([metaBackfill, responseBackfill]) => {
              if (!meta) {
                meta = metaBackfill;
              }
              if (!response) {
                response = responseBackfill;
              }
              if (responseBackfill.results) {
                backfillResults.push(...responseBackfill.results);
              }
            });
            response.pagination.pageSize = pageSize;
            response.pagination.totalPages = Math.ceil(response.pagination.totalResults / response.pagination.pageSize);
            response.pagination.page = params.pagination?.page;
            response.results = backfillResults;
            if (!response.meta) {
              response.meta = meta;
            }
          } else {
            [meta, response] = await this.client.search(params);
            if (!response.meta) {
              response.meta = meta;
            }
            response.results = [...this.previousResults, ...response.results || []];
          }
        } else {
          [meta, response] = await this.client.search(params);
          if (!response.meta) {
            response.meta = meta;
          }
        }
        searchProfile.stop();
        this.log.profile(searchProfile);
        const afterSearchProfile = this.profiler.create({ type: "event", name: "afterSearch", context: params }).start();
        try {
          await this.eventManager.fire("afterSearch", {
            controller: this,
            request: params,
            response
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'afterSearch' middleware cancelled`);
            afterSearchProfile.stop();
            return;
          } else {
            this.log.error(`error in 'afterSearch' middleware`);
            throw err;
          }
        }
        afterSearchProfile.stop();
        this.log.profile(afterSearchProfile);
        if (this.config.settings?.infinite) {
          this.previousResults = JSON.parse(JSON.stringify(response.results));
        }
        this.store.update(response);
        const afterStoreProfile = this.profiler.create({ type: "event", name: "afterStore", context: params }).start();
        try {
          await this.eventManager.fire("afterStore", {
            controller: this,
            request: params,
            response
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'afterStore' middleware cancelled`);
            afterStoreProfile.stop();
            return;
          } else {
            this.log.error(`error in 'afterStore' middleware`);
            throw err;
          }
        }
        afterStoreProfile.stop();
        this.log.profile(afterStoreProfile);
      } catch (err) {
        if (err) {
          if (err.err && err.fetchDetails) {
            switch (err.fetchDetails.status) {
              case 429: {
                this.store.error = {
                  code: 429,
                  type: ErrorType.WARNING,
                  message: "Too many requests try again later"
                };
                break;
              }
              case 500: {
                this.store.error = {
                  code: 500,
                  type: ErrorType.ERROR,
                  message: "Invalid Search Request or Service Unavailable"
                };
                break;
              }
              default: {
                this.store.error = {
                  type: ErrorType.ERROR,
                  message: err.err.message
                };
                break;
              }
            }
            this.log.error(this.store.error);
            this.handleError(err.err, err.fetchDetails);
          } else {
            this.store.error = {
              type: ErrorType.ERROR,
              message: `Something went wrong... - ${err}`
            };
            this.log.error(err);
            this.handleError(err);
          }
          this.store.loading = false;
        }
      }
    };
    this.config = (0, import_deepmerge2.default)(defaultConfig2, this.config);
    if (this.config.settings?.infinite && typeof this.config.settings.restorePosition == "undefined") {
      this.config.settings.restorePosition = { enabled: true };
    }
    this.store.setConfig(this.config);
    this.storage = new StorageStore({
      type: StorageType.SESSION,
      key: `ss-controller-${this.config.id}`
    });
    this.storage.set("lastStringyParams", void 0);
    this.eventManager.on("beforeSearch", async (search, next) => {
      search.controller.store.loading = true;
      await next();
    });
    this.eventManager.on("afterSearch", async (search, next) => {
      const config2 = search.controller.config;
      const redirectURL = search.response?.merchandising?.redirect;
      const searchStore = search.controller.store;
      if (redirectURL && config2?.settings?.redirects?.merchandising && !search?.response?.filters?.length && !searchStore.loaded) {
        window.location.replace(redirectURL);
        return false;
      }
      const nonBackgroundFilters = search?.request?.filters?.filter((filter) => !filter.background);
      if (config2?.settings?.redirects?.singleResult && search?.response?.search?.query && search?.response?.pagination?.totalResults === 1 && !nonBackgroundFilters?.length && !search.controller.previousResults.length) {
        window.location.replace(search?.response.results[0].mappings.core.url);
        return false;
      }
      await next();
    });
    this.eventManager.on("afterStore", async (search, next) => {
      await next();
      this.storage.set("lastStringyParams", JSON.stringify(search.request));
      const storableRequestParams = getStorableRequestParams(search.request);
      const stringyParams = JSON.stringify(storableRequestParams);
      const scrollMap = this.storage.get("scrollMap") || {};
      const elementPosition = scrollMap[stringyParams];
      if (!elementPosition) {
        this.storage.set("scrollMap", {});
      }
      await this.eventManager.fire("restorePosition", { controller: this, element: elementPosition });
      search.controller.store.loading = false;
    });
    if (this.config.settings?.restorePosition?.enabled) {
      this.eventManager.on("restorePosition", async ({ controller, element }, next) => {
        const scrollToPosition = () => {
          return new Promise(async (resolve) => {
            const maxCheckTime = 500;
            const checkTime = 50;
            const maxScrolls = Math.ceil(maxCheckTime / checkTime);
            const maxCheckCount = maxScrolls + 2;
            let scrollBackCount = 0;
            let checkCount = 0;
            let scrolledElem = void 0;
            const checkAndScroll = () => {
              let offset = element?.domRect?.top || 0;
              let elem = document.querySelector(element?.selector);
              while (elem && !elem.getBoundingClientRect().height) {
                elem = elem.parentElement;
                offset = 0;
              }
              if (elem) {
                const { y } = elem.getBoundingClientRect();
                scrollBackCount++;
                if (y > offset + 1 || y < offset - 1) {
                  window.scrollBy(0, y - offset);
                } else {
                  scrolledElem = elem;
                }
              } else {
                checkCount++;
              }
              return true;
            };
            while (checkAndScroll() && scrollBackCount <= maxScrolls && checkCount <= maxCheckCount) {
              await new Promise((resolve2) => setTimeout(resolve2, checkTime));
            }
            if (scrolledElem) {
              controller.log.debug("restored position to: ", scrolledElem);
            } else {
              controller.log.debug("attempted to scroll back to element with selector: ", element?.selector);
            }
            resolve();
          });
        };
        if (element)
          await scrollToPosition();
        await next();
      });
    }
    this.use(this.config);
  }
  get params() {
    const params = (0, import_deepmerge2.default)({ ...getSearchParams(this.urlManager.state) }, this.config.globals || {});
    if (!this.config.settings?.redirects?.merchandising || this.store.loaded) {
      params.search = params.search || {};
      params.search.redirectResponse = "full";
    }
    params.tracking = params.tracking || {};
    params.tracking.domain = window.location.href;
    const userId = this.tracker.getUserId();
    if (userId) {
      params.tracking.userId = userId;
    }
    const sessionId = this.tracker.getContext().sessionId;
    if (sessionId) {
      params.tracking.sessionId = sessionId;
    }
    const pageId = this.tracker.getContext().pageLoadId;
    if (pageId) {
      params.tracking.pageLoadId = pageId;
    }
    if (!this.config.globals?.personalization?.disabled) {
      const cartItems = this.tracker.cookies.cart.get();
      if (cartItems.length) {
        params.personalization = params.personalization || {};
        params.personalization.cart = cartItems.join(",");
      }
      const lastViewedItems = this.tracker.cookies.viewed.get();
      if (lastViewedItems.length) {
        params.personalization = params.personalization || {};
        params.personalization.lastViewed = lastViewedItems.join(",");
      }
      const shopperId = this.tracker.getShopperId();
      if (shopperId) {
        params.personalization = params.personalization || {};
        params.personalization.shopper = shopperId;
      }
    }
    return params;
  }
};
function getStorableRequestParams(request) {
  return {
    siteId: request.siteId,
    sorts: request.sorts,
    search: {
      query: {
        string: request?.search?.query?.string || ""
      },
      subQuery: request?.search?.subQuery || ""
    },
    filters: request.filters,
    pagination: request.pagination,
    facets: request.facets,
    merchandising: {
      landingPage: request.merchandising?.landingPage || ""
    }
  };
}
function generateHrefSelector(element, href, levels = 7) {
  let level = 0;
  let elem = element;
  while (elem && level <= levels) {
    const innerHrefElem = elem.querySelector(`[href*="${href}"]`);
    if (innerHrefElem) {
      let selector = "";
      let parentElem = innerHrefElem;
      while (parentElem && parentElem != elem.parentElement) {
        const classNames = parentElem.classList.value.trim().split(" ");
        const escapedClassSelector = classNames.reduce((classes, classname) => classname.trim() ? `${classes}.${(0, import_css.default)(classname.trim())}` : classes, "");
        selector = `${parentElem.tagName}${escapedClassSelector}${selector ? ` ${selector}` : ""}`;
        parentElem = parentElem.parentElement;
      }
      return `${selector}[href*="${href}"]`;
    }
    elem = elem.parentElement;
    level++;
  }
  return;
}
function backFillSize(pages, pageSize) {
  const totalResults = pages * pageSize;
  let numPages = Math.ceil(totalResults / API_LIMIT);
  while (totalResults % numPages)
    numPages++;
  return { size: totalResults / numPages, pages: numPages };
}

// node_modules/@searchspring/snap-controller/dist/esm/Autocomplete/AutocompleteController.js
var import_deepmerge3 = __toESM(require_cjs());
var INPUT_ATTRIBUTE = "ss-autocomplete-input";
var INPUT_DELAY = 200;
var KEY_ENTER = 13;
var KEY_ESCAPE = 27;
var PARAM_ORIGINAL_QUERY = "oq";
var PARAM_FALLBACK_QUERY = "fallbackQuery";
var defaultConfig3 = {
  id: "autocomplete",
  selector: "",
  action: "",
  globals: {},
  settings: {
    integratedSpellCorrection: false,
    initializeFromUrl: true,
    syncInputs: true,
    serializeForm: false,
    facets: {
      trim: true,
      pinFiltered: true
    },
    redirects: {
      merchandising: true
    }
  }
};
var AutocompleteController = class extends AbstractController {
  constructor(config, { client, store, urlManager, eventManager, profiler, logger, tracker }, context) {
    super(config, { client, store, urlManager, eventManager, profiler, logger, tracker }, context);
    this.type = ControllerTypes.autocomplete;
    this.track = {
      // TODO: add in future when autocomplete supports result click tracking
      product: {
        click: () => {
          this.log.warn("product.click tracking is not currently supported in this controller type");
        }
      }
    };
    this.handlers = {
      input: {
        enterKey: async (e) => {
          if (e.keyCode == KEY_ENTER) {
            const input = e.target;
            let actionUrl = this.store.services.urlManager;
            e.preventDefault();
            if (this.config.globals?.search?.query?.spellCorrection) {
              await timeout(INPUT_DELAY + 1);
              while (this.store.loading) {
                await timeout(INPUT_DELAY);
              }
              if (this.config.settings.integratedSpellCorrection) {
                if (this.store.search.correctedQuery) {
                  actionUrl = actionUrl?.set(PARAM_FALLBACK_QUERY, this.store.search.correctedQuery.string);
                }
              } else if (this.store.search.originalQuery) {
                input.value = this.store.search.query?.string;
                actionUrl = actionUrl?.set(PARAM_ORIGINAL_QUERY, this.store.search.originalQuery.string);
              }
            }
            actionUrl = actionUrl?.set("query", input.value);
            try {
              await this.eventManager.fire("beforeSubmit", {
                controller: this,
                input
              });
            } catch (err) {
              if (err?.message == "cancelled") {
                this.log.warn(`'beforeSubmit' middleware cancelled`);
                return;
              } else {
                this.log.error(`error in 'beforeSubmit' middleware`);
                console.error(err);
              }
            }
            window.location.href = actionUrl?.href || "";
          }
        },
        escKey: (e) => {
          if (e.keyCode == KEY_ESCAPE) {
            e.target.blur();
            this.setFocused();
          }
        },
        focus: (e) => {
          e.stopPropagation();
          setTimeout(() => {
            this.setFocused(e.target);
          });
        },
        formSubmit: async (e) => {
          const form = e.target;
          const input = form.querySelector(`input[${INPUT_ATTRIBUTE}]`);
          e.preventDefault();
          if (this.config.globals?.search?.query?.spellCorrection) {
            await timeout(INPUT_DELAY + 1);
            while (this.store.loading) {
              await timeout(INPUT_DELAY);
            }
            if (this.config.settings.integratedSpellCorrection) {
              if (this.store.search.correctedQuery) {
                addHiddenFormInput(form, PARAM_FALLBACK_QUERY, this.store.search.correctedQuery.string);
              }
            } else if (this.store.search.originalQuery) {
              if (input) {
                input.value = this.store.search.query?.string;
              }
              addHiddenFormInput(form, PARAM_ORIGINAL_QUERY, this.store.search.originalQuery.string);
            }
          }
          try {
            await this.eventManager.fire("beforeSubmit", {
              controller: this,
              input
            });
          } catch (err) {
            if (err?.message == "cancelled") {
              this.log.warn(`'beforeSubmit' middleware cancelled`);
              return;
            } else {
              this.log.error(`error in 'beforeSubmit' middleware`);
              console.error(err);
            }
          }
          form.submit();
        },
        formElementChange: (e) => {
          const input = e.target;
          const form = input?.form;
          const searchInput = form?.querySelector(`input[${INPUT_ATTRIBUTE}]`);
          if (form && searchInput && this.config.settings?.serializeForm) {
            const formParameters = getFormParameters(form, function(elem) {
              return elem != searchInput;
            });
            this.store.setService("urlManager", this.store.services.urlManager.reset().withGlobals(formParameters));
            this.store.reset();
            if (this.config.settings?.trending?.limit && this.config.settings?.trending?.limit > 0) {
              this.searchTrending();
            }
          }
        },
        keyUp: (e) => {
          if (e?.keyCode == KEY_ENTER || e?.keyCode == KEY_ESCAPE)
            return;
          if (e.isTrusted && this.store.state.focusedInput !== e.target) {
            this.setFocused(e.target);
          }
          const value = e.target.value;
          if ((!this.store.state.input && !value || this.store.state.input == value) && this.store.loaded) {
            return;
          }
          this.store.state.input = value;
          if (this.config?.settings?.syncInputs) {
            const inputs = document.querySelectorAll(this.config.selector);
            inputs.forEach((input) => {
              input.value = value;
            });
          }
          clearTimeout(this.handlers.input.timeoutDelay);
          const trendingResultsEnabled = this.store.trending?.length && this.config.settings?.trending?.showResults;
          const historyResultsEnabled = this.store.history?.length && this.config.settings?.history?.showResults;
          this.urlManager.reset().go();
          if (!value) {
            this.store.reset();
            if (trendingResultsEnabled) {
              this.store.trending[0].preview();
            } else if (historyResultsEnabled) {
              this.store.history[0].preview();
            }
          } else {
            this.handlers.input.timeoutDelay = setTimeout(() => {
              this.store.state.locks.terms.unlock();
              this.store.state.locks.facets.unlock();
              this.urlManager.set({ query: this.store.state.input }).go();
            }, INPUT_DELAY);
          }
        },
        timeoutDelay: void 0
      },
      document: {
        click: (e) => {
          const inputs = document.querySelectorAll(this.config.selector);
          if (Array.from(inputs).includes(e.target)) {
            e.stopPropagation();
          } else {
            this.setFocused();
          }
        }
      }
    };
    this.searchTrending = async () => {
      let terms;
      const storedTerms = this.storage.get("terms");
      if (storedTerms) {
        terms = JSON.parse(storedTerms);
      } else {
        const trendingParams = {
          limit: this.config.settings?.trending?.limit || 5
        };
        const trendingProfile = this.profiler.create({ type: "event", name: "trending", context: trendingParams }).start();
        terms = await this.client.trending(trendingParams);
        trendingProfile.stop();
        this.log.profile(trendingProfile);
        if (terms?.trending?.queries?.length) {
          this.storage.set("terms", JSON.stringify(terms));
        }
      }
      this.store.updateTrendingTerms(terms);
    };
    this.search = async () => {
      if (!this.urlManager.state.query) {
        return;
      }
      const params = this.params;
      if (!params?.search?.query?.string) {
        return;
      }
      try {
        try {
          await this.eventManager.fire("beforeSearch", {
            controller: this,
            request: params
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'beforeSearch' middleware cancelled`);
            return;
          } else {
            this.log.error(`error in 'beforeSearch' middleware`);
            throw err;
          }
        }
        const searchProfile = this.profiler.create({ type: "event", name: "search", context: params }).start();
        const [meta, response] = await this.client.autocomplete(params);
        if (!response.meta) {
          response.meta = meta;
        }
        searchProfile.stop();
        this.log.profile(searchProfile);
        const afterSearchProfile = this.profiler.create({ type: "event", name: "afterSearch", context: params }).start();
        try {
          await this.eventManager.fire("afterSearch", {
            controller: this,
            request: params,
            response
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'afterSearch' middleware cancelled`);
            afterSearchProfile.stop();
            return;
          } else {
            this.log.error(`error in 'afterSearch' middleware`);
            throw err;
          }
        }
        afterSearchProfile.stop();
        this.log.profile(afterSearchProfile);
        this.store.update(response);
        const afterStoreProfile = this.profiler.create({ type: "event", name: "afterStore", context: params }).start();
        try {
          await this.eventManager.fire("afterStore", {
            controller: this,
            request: params,
            response
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'afterStore' middleware cancelled`);
            afterStoreProfile.stop();
            return;
          } else {
            this.log.error(`error in 'afterStore' middleware`);
            throw err;
          }
        }
        afterStoreProfile.stop();
        this.log.profile(afterStoreProfile);
      } catch (err) {
        if (err) {
          if (err.err && err.fetchDetails) {
            switch (err.fetchDetails.status) {
              case 429: {
                this.store.error = {
                  code: 429,
                  type: ErrorType.WARNING,
                  message: "Too many requests try again later"
                };
                break;
              }
              case 500: {
                this.store.error = {
                  code: 500,
                  type: ErrorType.ERROR,
                  message: "Invalid Search Request or Service Unavailable"
                };
                break;
              }
              default: {
                this.store.error = {
                  type: ErrorType.ERROR,
                  message: err.err.message
                };
                break;
              }
            }
            this.log.error(this.store.error);
            this.handleError(err.err, err.fetchDetails);
          } else {
            this.store.error = {
              type: ErrorType.ERROR,
              message: `Something went wrong... - ${err}`
            };
            this.log.error(err);
            this.handleError(err);
          }
          this.store.loading = false;
        }
      }
    };
    this.config = (0, import_deepmerge3.default)(defaultConfig3, this.config);
    this.store.setConfig(this.config);
    if (this.config.settings.initializeFromUrl) {
      this.store.state.input = this.urlManager.state.query;
      this.urlManager.reset().go();
    }
    this.storage = new StorageStore({
      type: StorageType.SESSION,
      key: `ss-controller-${this.config.id}`
    });
    this.eventManager.on("beforeSearch", async (ac, next) => {
      ac.controller.store.loading = true;
      await next();
    });
    this.eventManager.on("afterSearch", async (ac, next) => {
      await next();
      if (ac.response.autocomplete.query != ac.controller.urlManager.state.query) {
        ac.controller.store.loading = false;
        return false;
      }
    });
    this.eventManager.on("afterStore", async (ac, next) => {
      await next();
      ac.controller.store.loading = false;
    });
    this.eventManager.on("beforeSubmit", async (ac, next) => {
      await next();
      const redirectURL = ac.controller.store.merchandising?.redirect;
      if (redirectURL && this.config?.settings?.redirects?.merchandising) {
        window.location.href = redirectURL;
        return false;
      }
    });
    this.use(this.config);
  }
  get params() {
    const urlState = this.urlManager.state;
    const params = (0, import_deepmerge3.default)({ ...getSearchParams(urlState) }, this.config.globals);
    const userId = this.tracker.getUserId();
    const sessionId = this.tracker.getContext().sessionId;
    const pageLoadId = this.tracker.getContext().pageLoadId;
    params.tracking = params.tracking || {};
    params.tracking.domain = window.location.href;
    if (userId) {
      params.tracking.userId = userId;
    }
    if (sessionId) {
      params.tracking.sessionId = sessionId;
    }
    if (pageLoadId) {
      params.tracking.pageLoadId = pageLoadId;
    }
    if (!this.config.globals?.personalization?.disabled) {
      const cartItems = this.tracker.cookies.cart.get();
      if (cartItems.length) {
        params.personalization = params.personalization || {};
        params.personalization.cart = cartItems.join(",");
      }
      const lastViewedItems = this.tracker.cookies.viewed.get();
      if (lastViewedItems.length) {
        params.personalization = params.personalization || {};
        params.personalization.lastViewed = lastViewedItems.join(",");
      }
      const shopperId = this.tracker.getShopperId();
      if (shopperId) {
        params.personalization = params.personalization || {};
        params.personalization.shopper = shopperId;
      }
    }
    return params;
  }
  async setFocused(inputElement) {
    if (this.store.state.focusedInput !== inputElement) {
      this.store.state.focusedInput = inputElement;
      try {
        try {
          await this.eventManager.fire("focusChange", {
            controller: this
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'focusChange' middleware cancelled`);
          } else {
            this.log.error(`error in 'focusChange' middleware`);
            throw err;
          }
        }
      } catch (err) {
        if (err) {
          console.error(err);
        }
      }
    }
    inputElement?.dispatchEvent(new Event("keyup"));
  }
  reset() {
    const inputs = document.querySelectorAll(this.config.selector);
    inputs.forEach((input) => {
      input.value = "";
    });
    this.store.reset();
  }
  unbind() {
    const inputs = document.querySelectorAll(`input[${INPUT_ATTRIBUTE}]`);
    inputs?.forEach((input) => {
      input.removeEventListener("keyup", this.handlers.input.keyUp);
      input.removeEventListener("keydown", this.handlers.input.enterKey);
      input.removeEventListener("keydown", this.handlers.input.escKey);
      input.removeEventListener("focus", this.handlers.input.focus);
      if (input.form) {
        input.form.removeEventListener("submit", this.handlers.input.formSubmit);
        unbindFormParameters(input.form, this.handlers.input.formElementChange);
      }
    });
    document.removeEventListener("click", this.handlers.document.click);
  }
  async bind() {
    if (!this.initialized) {
      await this.init();
    }
    this.unbind();
    const inputs = document.querySelectorAll(this.config.selector);
    inputs.forEach((input) => {
      input.setAttribute("spellcheck", "false");
      input.setAttribute("autocomplete", "off");
      input.setAttribute("autocorrect", "off");
      input.setAttribute("autocapitalize", "none");
      input.setAttribute(INPUT_ATTRIBUTE, "");
      input.addEventListener("keyup", this.handlers.input.keyUp);
      if (this.config?.settings?.initializeFromUrl && !input.value && this.store.state.input) {
        input.value = this.store.state.input;
      }
      input.addEventListener("focus", this.handlers.input.focus);
      input.addEventListener("keydown", this.handlers.input.escKey);
      const form = input.form;
      let formActionUrl;
      if (this.config.action) {
        input.addEventListener("keydown", this.handlers.input.enterKey);
        formActionUrl = this.config.action;
      } else if (form) {
        form.addEventListener("submit", this.handlers.input.formSubmit);
        formActionUrl = form.action || "";
        if (this.config.settings?.serializeForm) {
          bindFormParameters(form, this.handlers.input.formElementChange, function(elem) {
            return elem != input;
          });
          const formParameters = getFormParameters(form, function(elem) {
            return elem != input;
          });
          this.store.setService("urlManager", this.urlManager.reset().withGlobals(formParameters));
        }
      }
      if (formActionUrl) {
        this.store.setService("urlManager", this.store.services.urlManager.withConfig((translatorConfig) => {
          return {
            ...translatorConfig,
            urlRoot: formActionUrl
          };
        }));
      }
      if (document.activeElement === input && !this.store.loading) {
        this.setFocused(input);
      }
    });
    if (this.config.settings?.trending?.limit && this.config.settings?.trending?.limit > 0 && !this.store.trending?.length) {
      this.searchTrending();
    }
    document.addEventListener("click", this.handlers.document.click);
  }
};
function addHiddenFormInput(form, name, value) {
  const inputElem = document.createElement("input");
  inputElem.type = "hidden";
  inputElem.name = name;
  inputElem.value = value;
  form.querySelector(`[type="hidden"][name="${name}"]`)?.remove();
  form.append(inputElem);
}
async function timeout(time) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, time);
  });
}
var INPUT_TYPE_BLOCKLIST = ["file", "reset", "submit", "button", "image", "password"];
function getFormParameters(form, filterFn) {
  const parameters = {};
  if (typeof form == "object" && form.nodeName == "FORM") {
    for (let i = form.elements.length - 1; i >= 0; i--) {
      const elem = form.elements[i];
      if (typeof filterFn == "function" && !filterFn(elem)) {
        continue;
      }
      if (elem.name && !INPUT_TYPE_BLOCKLIST.includes(elem.type)) {
        if (elem.type != "checkbox" && elem.type != "radio" || elem.checked) {
          parameters[elem.name] = elem.value;
        }
      }
    }
  }
  return parameters;
}
function bindFormParameters(form, fn, filterFn) {
  if (typeof form == "object" && form.nodeName == "FORM") {
    for (let i = form.elements.length - 1; i >= 0; i--) {
      const elem = form.elements[i];
      if (typeof filterFn == "function" && !filterFn(elem)) {
        continue;
      }
      if (elem.name && !INPUT_TYPE_BLOCKLIST.includes(elem.type)) {
        elem.addEventListener("change", fn);
      }
    }
  }
}
function unbindFormParameters(form, fn) {
  if (typeof form == "object" && form.nodeName == "FORM") {
    for (let i = form.elements.length - 1; i >= 0; i--) {
      const elem = form.elements[i];
      if (elem.name && !INPUT_TYPE_BLOCKLIST.includes(elem.type)) {
        elem.removeEventListener("change", fn);
      }
    }
  }
}

// node_modules/@searchspring/snap-controller/dist/esm/Recommendation/RecommendationController.js
var import_deepmerge4 = __toESM(require_cjs());
var defaultConfig4 = {
  id: "recommend",
  tag: "",
  batched: true,
  realtime: false,
  globals: {}
};
var RecommendationController = class extends AbstractController {
  constructor(config, { client, store, urlManager, eventManager, profiler, logger, tracker }, context) {
    super(config, { client, store, urlManager, eventManager, profiler, logger, tracker }, context);
    this.type = ControllerTypes.recommendation;
    this.events = {
      click: void 0,
      impression: void 0,
      render: void 0,
      product: {}
    };
    this.track = /* @__PURE__ */ (() => {
      const getSeed = () => {
        let skus = [];
        switch (this.store.profile.placement) {
          case ProfilePlacement.PRODUCTPAGE:
            if (this.config.globals.product) {
              skus = [this.config.globals.product];
            }
            break;
          case ProfilePlacement.BASKETPAGE:
            skus = this.tracker.cookies.cart.get();
            break;
          default:
            return;
        }
        if (skus.length) {
          return skus.map((sku) => ({
            sku
          }));
        }
      };
      return {
        product: {
          click: (e, result) => {
            if (!this.store.profile.tag || !result)
              return;
            this.track.click(e);
            const payload = {
              type: BeaconType.PROFILE_PRODUCT_CLICK,
              category: BeaconCategory.RECOMMENDATIONS,
              context: this.config.globals.siteId ? { website: { trackingCode: this.config.globals.siteId } } : void 0,
              event: {
                context: {
                  action: "navigate",
                  placement: this.store.profile.placement,
                  tag: this.store.profile.tag,
                  type: "product-recommendation"
                },
                product: {
                  id: result.id,
                  mappings: {
                    core: result.mappings.core
                  },
                  seed: getSeed()
                }
              },
              pid: this.events.click?.id
            };
            const event = this.tracker.track.event(payload);
            this.eventManager.fire("track.product.click", { controller: this, event: e, result, trackEvent: event });
            return event;
          },
          impression: (result) => {
            if (!this.store.profile.tag || !result || !this.events.impression || this.events.product && this.events.product[result.id]?.impression)
              return;
            const payload = {
              type: BeaconType.PROFILE_PRODUCT_IMPRESSION,
              category: BeaconCategory.RECOMMENDATIONS,
              context: this.config.globals.siteId ? { website: { trackingCode: this.config.globals.siteId } } : void 0,
              event: {
                context: {
                  placement: this.store.profile.placement,
                  tag: this.store.profile.tag,
                  type: "product-recommendation"
                },
                product: {
                  id: result.id,
                  mappings: {
                    core: result.mappings.core
                  },
                  seed: getSeed()
                }
              },
              pid: this.events.impression.id
            };
            this.events.product[result.id] = this.events.product[result.id] || {};
            const event = this.events.product[result.id].impression = this.tracker.track.event(payload);
            this.eventManager.fire("track.product.impression", { controller: this, result, trackEvent: event });
            return event;
          },
          render: (result) => {
            if (!this.store.profile.tag || !result || !this.events.render || this.events.product[result.id]?.render)
              return;
            const payload = {
              type: BeaconType.PROFILE_PRODUCT_RENDER,
              category: BeaconCategory.RECOMMENDATIONS,
              context: this.config.globals.siteId ? { website: { trackingCode: this.config.globals.siteId } } : void 0,
              event: {
                context: {
                  placement: this.store.profile.placement,
                  tag: this.store.profile.tag,
                  type: "product-recommendation"
                },
                product: {
                  id: result.id,
                  mappings: {
                    core: result.mappings.core
                  },
                  seed: getSeed()
                }
              },
              pid: this.events.render.id
            };
            this.events.product[result.id] = this.events.product[result.id] || {};
            const event = this.events.product[result.id].render = this.tracker.track.event(payload);
            this.eventManager.fire("track.product.render", { controller: this, result, trackEvent: event });
            return event;
          }
        },
        click: (e) => {
          if (!this.store.profile.tag)
            return;
          const event = this.tracker.track.event({
            type: BeaconType.PROFILE_CLICK,
            category: BeaconCategory.RECOMMENDATIONS,
            context: this.config.globals.siteId ? { website: { trackingCode: this.config.globals.siteId } } : void 0,
            event: {
              context: {
                action: "navigate",
                placement: this.store.profile.placement,
                tag: this.store.profile.tag,
                type: "product-recommendation"
              },
              profile: {
                tag: this.store.profile.tag,
                placement: this.store.profile.placement,
                threshold: this.store.profile.display.threshold,
                templateId: this.store.profile.display.template.uuid,
                seed: getSeed()
              }
            }
          });
          this.events.click = event;
          this.eventManager.fire("track.click", { controller: this, event: e, trackEvent: event });
          return event;
        },
        impression: () => {
          if (!this.store.profile.tag || this.events.impression)
            return;
          const event = this.tracker.track.event({
            type: BeaconType.PROFILE_IMPRESSION,
            category: BeaconCategory.RECOMMENDATIONS,
            context: this.config.globals.siteId ? { website: { trackingCode: this.config.globals.siteId } } : void 0,
            event: {
              context: {
                placement: this.store.profile.placement,
                tag: this.store.profile.tag,
                type: "product-recommendation"
              },
              profile: {
                tag: this.store.profile.tag,
                placement: this.store.profile.placement,
                threshold: this.store.profile.display.threshold,
                templateId: this.store.profile.display.template.uuid,
                seed: getSeed()
              }
            }
          });
          this.events.impression = event;
          this.eventManager.fire("track.impression", { controller: this, trackEvent: event });
          return event;
        },
        render: () => {
          if (!this.store.profile.tag || this.events.render)
            return;
          const event = this.tracker.track.event({
            type: BeaconType.PROFILE_RENDER,
            category: BeaconCategory.RECOMMENDATIONS,
            context: this.config.globals.siteId ? { website: { trackingCode: this.config.globals.siteId } } : void 0,
            event: {
              context: {
                placement: this.store.profile.placement,
                tag: this.store.profile.tag,
                type: "product-recommendation"
              },
              profile: {
                tag: this.store.profile.tag,
                placement: this.store.profile.placement,
                threshold: this.store.profile.display.threshold,
                templateId: this.store.profile.display.template.uuid,
                seed: getSeed()
              }
            }
          });
          this.events.render = event;
          this.eventManager.fire("track.render", { controller: this, trackEvent: event });
          return event;
        }
      };
    })();
    this.search = async () => {
      if (!this.initialized) {
        await this.init();
      }
      const params = this.params;
      try {
        try {
          await this.eventManager.fire("beforeSearch", {
            controller: this,
            request: params
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'beforeSearch' middleware cancelled`);
            return;
          } else {
            this.log.error(`error in 'beforeSearch' middleware`);
            throw err;
          }
        }
        const searchProfile = this.profiler.create({ type: "event", name: "search", context: params }).start();
        const response = await this.client.recommend(params);
        searchProfile.stop();
        this.log.profile(searchProfile);
        const afterSearchProfile = this.profiler.create({ type: "event", name: "afterSearch", context: params }).start();
        try {
          await this.eventManager.fire("afterSearch", {
            controller: this,
            request: params,
            response
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'afterSearch' middleware cancelled`);
            afterSearchProfile.stop();
            return;
          } else {
            this.log.error(`error in 'afterSearch' middleware`);
            throw err;
          }
        }
        afterSearchProfile.stop();
        this.log.profile(afterSearchProfile);
        this.store.update(response);
        const afterStoreProfile = this.profiler.create({ type: "event", name: "afterStore", context: params }).start();
        try {
          await this.eventManager.fire("afterStore", {
            controller: this,
            request: params,
            response
          });
        } catch (err) {
          if (err?.message == "cancelled") {
            this.log.warn(`'afterStore' middleware cancelled`);
            afterStoreProfile.stop();
            return;
          } else {
            this.log.error(`error in 'afterStore' middleware`);
            throw err;
          }
        }
        afterStoreProfile.stop();
        this.log.profile(afterStoreProfile);
      } catch (err) {
        if (err) {
          if (err.err && err.fetchDetails) {
            switch (err.fetchDetails.status) {
              case 429: {
                this.store.error = {
                  code: 429,
                  type: ErrorType.WARNING,
                  message: "Too many requests try again later"
                };
                break;
              }
              case 500: {
                this.store.error = {
                  code: 500,
                  type: ErrorType.ERROR,
                  message: "Invalid Search Request or Service Unavailable"
                };
                break;
              }
              default: {
                this.store.error = {
                  type: ErrorType.ERROR,
                  message: err.err.message
                };
                break;
              }
            }
            this.log.error(this.store.error);
            this.handleError(err.err, err.fetchDetails);
          } else {
            this.store.error = {
              type: ErrorType.ERROR,
              message: `Something went wrong... - ${err}`
            };
            this.log.error(err);
            this.handleError(err);
          }
          this.store.loading = false;
        }
      }
    };
    if (!config.tag) {
      throw new Error(`Invalid config passed to RecommendationController. The "tag" attribute is required.`);
    }
    this.config = (0, import_deepmerge4.default)(defaultConfig4, this.config);
    this.store.setConfig(this.config);
    this.eventManager.on("beforeSearch", async (recommend, next) => {
      recommend.controller.store.loading = true;
      await next();
    });
    this.eventManager.on("afterStore", async (recommend, next) => {
      await next();
      recommend.controller.store.loading = false;
    });
    this.use(this.config);
  }
  get params() {
    const params = {
      tag: this.config.tag,
      batched: this.config.batched,
      branch: this.config.branch || "production",
      order: this.context?.options?.order,
      ...this.config.globals
    };
    const shopperId = this.tracker.getContext().shopperId;
    const cart = this.tracker.cookies.cart.get();
    const lastViewed = this.tracker.cookies.viewed.get();
    if (shopperId) {
      params.shopper = shopperId;
    }
    if (!params.siteId || params.siteId == this.tracker.getGlobals().siteId) {
      if (cart?.length) {
        params.cart = cart;
      }
      if (lastViewed?.length) {
        params.lastViewed = lastViewed;
      }
    }
    return params;
  }
};

// node_modules/@searchspring/snap-url-manager/dist/esm/UrlManager/UrlManager.js
var import_seamless_immutable = __toESM(require_seamless_immutable_development());
var WatcherPool = class {
  constructor() {
    this.callbacks = [];
  }
  subscribe(cb) {
    this.callbacks.push(cb);
    return () => this.callbacks = this.callbacks.filter((_cb) => _cb != cb);
  }
  notify() {
    this.callbacks.forEach((cb) => cb());
  }
};
var UrlManager = class _UrlManager {
  constructor(translator, linker, globalState, localState, watcherPool, omissions = [], detached) {
    this.linker = linker;
    this.omissions = omissions;
    this.detached = detached;
    this.urlState = (0, import_seamless_immutable.default)({});
    this.globalState = (0, import_seamless_immutable.default)({});
    this.localState = (0, import_seamless_immutable.default)({});
    this.mergedState = (0, import_seamless_immutable.default)({});
    this.localState = (0, import_seamless_immutable.default)(localState || {});
    this.globalState = (0, import_seamless_immutable.default)(globalState || {});
    this.translator = translator;
    const translatorConfig = this.getTranslatorConfig();
    if (translatorConfig.urlRoot && translatorConfig.settings?.serializeUrlRoot) {
      this.globalState = this.globalState.merge((0, import_seamless_immutable.default)(this.translator.deserialize(translatorConfig.urlRoot)), {
        deep: true,
        merger: arrayConcatMerger
      });
    }
    if (watcherPool) {
      this.watcherPool = watcherPool;
    } else {
      this.watcherPool = new WatcherPool();
      if (this.translator.bindExternalEvents instanceof Function) {
        this.translator.bindExternalEvents(() => this.watcherPool.notify());
      }
    }
    this.subscribe(() => {
      this.refresh();
    });
    this.refresh();
  }
  without(obj, fullPath, values) {
    const path = fullPath.slice(0, -1);
    const lastKey = fullPath[fullPath.length - 1];
    if (!path.length) {
      if (!values?.length) {
        return obj.without(lastKey);
      }
      return updateNode(lastKey, obj);
    }
    if (!obj.getIn(path)) {
      return obj;
    }
    return obj.updateIn(path, (node) => {
      return updateNode(lastKey, node);
    });
    function updateNode(key, node) {
      if (node[lastKey] === void 0) {
        return node;
      }
      if (node[lastKey] instanceof Array) {
        if (!values || !values.length) {
          return node.without(lastKey);
        }
        return node.set(lastKey, node[lastKey].filter((value) => {
          return !values.some((removeValue) => {
            return compareObjects(value, removeValue);
          });
        }));
      }
      if (typeof node == "object") {
        return node.without(lastKey);
      }
      return node;
    }
  }
  getTranslatorUrl() {
    if (this.detached) {
      return this.detached.url;
    }
    return this.translator.getCurrentUrl();
  }
  refresh() {
    this.prevState = this.mergedState;
    this.urlState = this.omissions.reduce((state, om) => {
      return this.without(state, om.path, om.values);
    }, (0, import_seamless_immutable.default)(this.translator.deserialize(this.getTranslatorUrl())));
    this.mergedState = this.globalState.merge(this.urlState, {
      deep: true,
      merger: arrayConcatMerger
    });
    this.mergedState = this.mergedState.merge(this.localState, {
      deep: true,
      merger: arrayConcatMerger
    });
  }
  get state() {
    return this.mergedState;
  }
  unpackPathAndState(stateOrPath, _state) {
    const path = stateOrPath instanceof Array ? stateOrPath : typeof stateOrPath == "string" ? stateOrPath.split(".") : [];
    const state = !(stateOrPath instanceof Array) && typeof stateOrPath == "object" ? stateOrPath : _state === void 0 ? {} : _state;
    return { path, state };
  }
  set(...args) {
    const { path, state } = this.unpackPathAndState(args[0], args[1]);
    const newState = path.length ? this.localState.setIn(path, removeArrayDuplicates(state)) : removeArrayDuplicates(state);
    const omissions = removeArrayDuplicates(this.omissions.concat(path.length ? { path } : Object.keys(this.urlState).map((key) => ({ path: [key] }))));
    return new _UrlManager(this.translator, this.linker, this.globalState, newState, this.watcherPool, omissions, this.detached);
  }
  merge(...args) {
    const { path, state } = this.unpackPathAndState(args[0], args[1]);
    const newState = path.length ? this.localState.updateIn(path, (oldState) => {
      if (oldState instanceof Array) {
        const newValues = Array.isArray(state) ? state : [state];
        return removeArrayDuplicates(oldState.concat(newValues));
      } else if (typeof oldState == "object") {
        if (Array.isArray(state)) {
          return state.length ? removeArrayDuplicates([oldState].concat(state)) : oldState;
        } else {
          return oldState.merge(state, { deep: true, merger: arrayConcatMerger });
        }
      } else if (typeof oldState != "undefined") {
        const newValues = (Array.isArray(state) ? state : [state]).filter((value) => !compareObjects(value, oldState));
        return newValues.length ? removeArrayDuplicates([oldState].concat(newValues)) : oldState;
      } else if (typeof oldState == "undefined") {
        const urlState = this.urlState.getIn(path);
        if (urlState instanceof Array && !Array.isArray(state)) {
          return [state];
        }
      }
      return state;
    }) : this.localState.merge(state, { deep: true, merger: arrayConcatMerger });
    return new _UrlManager(this.translator, this.linker, this.globalState, newState, this.watcherPool, this.omissions, this.detached);
  }
  remove(_path, values) {
    const { path } = this.unpackPathAndState(_path, {});
    values = typeof values != "undefined" ? values instanceof Array ? values : [values] : [];
    const without = this.without(this.localState, path, values);
    const omissions = removeArrayDuplicates(this.omissions.concat({ path, values }));
    return new _UrlManager(this.translator, this.linker, this.globalState, without, this.watcherPool, omissions, this.detached);
  }
  reset() {
    if (this.detached) {
      this.detached.url = "";
    }
    return new _UrlManager(this.translator, this.linker, this.globalState, {}, this.watcherPool, Object.keys(this.urlState).map((k) => ({ path: [k] })), this.detached);
  }
  withConfig(config) {
    if (config instanceof Function) {
      config = config(this.translator.getConfig());
    }
    return new _UrlManager(new (Object.getPrototypeOf(this.translator)).constructor(config), this.linker, this.globalState, this.localState, this.watcherPool, this.omissions, this.detached);
  }
  withGlobals(globals) {
    this.globalState = this.globalState.merge((0, import_seamless_immutable.default)(globals), {
      deep: true,
      merger: arrayConcatMerger
    });
    return new _UrlManager(this.translator, this.linker, this.globalState, this.localState, this.watcherPool, this.omissions, this.detached);
  }
  getTranslatorConfig() {
    return this.translator.getConfig();
  }
  get href() {
    return this.translator.serialize(this.state);
  }
  go(config) {
    if (this.detached) {
      this.detached.url = this.href;
    } else {
      this.translator.go(this.href, config);
    }
    this.watcherPool.notify();
  }
  detach(reset = false) {
    return new _UrlManager(this.translator, this.linker, this.globalState, this.localState, new WatcherPool(), this.omissions, {
      url: reset ? "" : this.getTranslatorUrl()
    });
  }
  get link() {
    if (!this.linker) {
      return {};
    }
    return this.linker(this);
  }
  subscribe(cb) {
    return this.watcherPool.subscribe(() => {
      const prevState = this.prevState;
      const state = this.mergedState;
      cb(prevState, state);
    });
  }
};
function removeArrayDuplicates(array) {
  if (Array.isArray(array) && array.length) {
    return array.reduce((accu, item) => {
      if (!accu.some((keep) => compareObjects(keep, item))) {
        accu.push(item);
      }
      return accu;
    }, [array[0]]);
  }
  return array;
}
function arrayConcatMerger(current, other) {
  if (current instanceof Array && other instanceof Array) {
    return removeArrayDuplicates([...current, ...other]);
  }
}
function compareObjects(obj1, obj2) {
  if (!obj1 && !obj2) {
    return true;
  } else if (!obj1 && obj2 || obj1 && !obj2) {
    return false;
  }
  const primitives = ["string", "number", "boolean", "undefined"];
  const typeA = typeof obj1;
  const typeB = typeof obj2;
  if (typeA !== typeB)
    return false;
  if (primitives.includes(typeA))
    return obj1 === obj2;
  const isArrayA = Array.isArray(obj1);
  const isArrayB = Array.isArray(obj2);
  if (isArrayA !== isArrayB) {
    return false;
  }
  if (isArrayA) {
    if (obj1.length != obj2.length)
      return false;
    for (let i = 0; i < obj1.length; i++) {
      if (!compareObjects(obj1[i], obj2[i])) {
        return false;
      }
    }
  } else {
    if (!compareObjects(Object.keys(obj1).sort(), Object.keys(obj2).sort())) {
      return false;
    }
    let result = true;
    Object.keys(obj1).forEach((key) => {
      if (!compareObjects(obj1[key], obj2[key])) {
        result = false;
      }
    });
    return result;
  }
  return true;
}

// node_modules/@searchspring/snap-url-manager/dist/esm/Translators/Url/UrlTranslator.js
var import_deepmerge5 = __toESM(require_cjs());

// node_modules/@searchspring/snap-url-manager/dist/esm/types.js
var RangeValueProperties;
(function(RangeValueProperties2) {
  RangeValueProperties2["LOW"] = "low";
  RangeValueProperties2["HIGH"] = "high";
})(RangeValueProperties || (RangeValueProperties = {}));
var ParamLocationType;
(function(ParamLocationType2) {
  ParamLocationType2["hash"] = "hash";
  ParamLocationType2["query"] = "query";
})(ParamLocationType || (ParamLocationType = {}));

// node_modules/@searchspring/snap-url-manager/dist/esm/Translators/Url/UrlTranslator.js
var defaultConfig5 = {
  urlRoot: "",
  settings: {
    corePrefix: "",
    customType: ParamLocationType.query,
    serializeUrlRoot: true
  },
  parameters: {
    core: {
      query: { name: "q", type: ParamLocationType.query },
      oq: { name: "oq", type: ParamLocationType.query },
      rq: { name: "rq", type: ParamLocationType.query },
      tag: { name: "tag", type: ParamLocationType.query },
      page: { name: "page", type: ParamLocationType.query },
      pageSize: { name: "pageSize", type: ParamLocationType.hash },
      sort: { name: "sort", type: ParamLocationType.hash },
      filter: { name: "filter", type: ParamLocationType.hash },
      fallbackQuery: { name: "fallbackQuery", type: ParamLocationType.query }
    },
    custom: {}
  }
};
var CORE_FIELDS = ["query", "oq", "fallbackQuery", "rq", "tag", "page", "pageSize", "sort", "filter"];
var UrlTranslator = class {
  constructor(config) {
    this.reverseMapping = {};
    this.config = (0, import_deepmerge5.default)(defaultConfig5, config || {});
    Object.keys(this.config.parameters.core).forEach((param) => {
      const coreParam = this.config.parameters.core[param];
      if (this.config.settings.corePrefix) {
        coreParam.name = this.config.settings.corePrefix + coreParam.name;
      }
      const paramType = this.config.settings?.coreType;
      if (paramType && Object.values(ParamLocationType).includes(paramType)) {
        if (config?.parameters?.core && config.parameters?.core[param]?.type) {
          coreParam.type = config.parameters?.core[param]?.type;
        } else {
          coreParam.type = paramType;
        }
      }
      this.reverseMapping[coreParam.name] = param;
    });
    const implicit = this.config.settings?.customType;
    if (implicit && !Object.values(ParamLocationType).includes(implicit)) {
      this.config.settings.customType = ParamLocationType.hash;
    }
  }
  bindExternalEvents(update) {
    window.addEventListener("popstate", update);
  }
  getCurrentUrl() {
    return window.location.search + window.location.hash;
  }
  getConfig() {
    return (0, import_deepmerge5.default)({}, this.config);
  }
  deserialize(url) {
    const params = this.parseUrlParams(url);
    return this.paramsToState(params);
  }
  parseUrlParams(url) {
    const queryString = url.includes("?") ? (url.split("?").pop() || "").split("#").shift() || "" : "";
    const hashString = url.includes("#") ? url.substring(url.indexOf("#") + 1) || "" : "";
    return [...this.parseHashString(hashString), ...this.parseQueryString(queryString)];
  }
  parseQueryString(queryString) {
    const justQueryString = queryString.split("?").pop() || "";
    return justQueryString.split("&").filter((v) => v).map((kvPair) => {
      const [key, value] = kvPair.split("=").map((v) => decodeURIComponent(v.replace(/\+/g, " ")));
      return { key: key.split("."), value, type: ParamLocationType.query };
    }).filter((param) => {
      const isCoreField = this.reverseMapping[param.key[0]];
      return !isCoreField || isCoreField && param.value;
    });
  }
  parseHashString(hashString) {
    const params = [];
    const justHashString = hashString.split("#").join("/") || "";
    justHashString.split("/").filter((v) => v).map((hashEntries) => {
      return hashEntries.split(":").map((v) => decodeHashComponent(v));
    }).filter((param) => {
      const [key, value] = param;
      const isCoreField = this.reverseMapping[key];
      return !isCoreField || isCoreField && value;
    }).forEach((decodedHashEntries) => {
      if (decodedHashEntries.length == 1) {
        params.push({ key: [decodedHashEntries[0]], value: "", type: ParamLocationType.hash });
      } else if (decodedHashEntries.length && decodedHashEntries.length >= 2) {
        const isCoreField = this.reverseMapping[decodedHashEntries[0]];
        if (isCoreField && isCoreField == "filter" && decodedHashEntries.length == 4) {
          const [path0, path1, low, high] = decodedHashEntries;
          params.push({ key: [path0, path1, "low"], value: low, type: ParamLocationType.hash });
          params.push({ key: [path0, path1, "high"], value: high, type: ParamLocationType.hash });
        } else {
          const [value, ...keys] = decodedHashEntries.reverse();
          params.push({ key: keys.reverse(), value, type: ParamLocationType.hash });
        }
      }
    });
    return params;
  }
  // parse params into state
  paramsToState(params) {
    const coreOtherParams = [], coreFilterParams = [], coreSortParams = [], otherParams = [];
    params?.forEach((param) => {
      const coreStateKey = this.reverseMapping[param.key[0]];
      const coreConfig = this.config.parameters.core[coreStateKey];
      const customStateKey = this.config.parameters.custom[param.key[0]];
      if (coreStateKey) {
        switch (coreStateKey) {
          case "filter": {
            if (coreConfig.type == param.type)
              coreFilterParams.push(param);
            break;
          }
          case "sort": {
            if (coreConfig.type == param.type)
              coreSortParams.push(param);
            break;
          }
          default: {
            if (coreConfig.type == param.type)
              coreOtherParams.push(param);
            break;
          }
        }
      } else if (!CORE_FIELDS.includes(param.key[0])) {
        if (!customStateKey) {
          this.config.parameters.custom[param.key[0]] = {
            type: param.type || this.config.settings.customType
          };
        }
        otherParams.push(param);
      }
    });
    return {
      ...this.parseCoreOther(coreOtherParams),
      ...this.parseCoreFilter(coreFilterParams),
      ...this.parseCoreSort(coreSortParams),
      ...this.parseOther(otherParams)
    };
  }
  parseCoreOther(otherParams) {
    const state = {};
    const numberTypeParams = ["page", "pageSize"];
    if (!otherParams) {
      return {};
    }
    otherParams.forEach((param) => {
      const coreKey = this.reverseMapping[param.key[0]];
      if (numberTypeParams.includes(coreKey)) {
        const numValue = Number(param.value);
        if (coreKey == "page" && numValue > 1) {
          state[coreKey] = numValue;
        } else if (coreKey != "page") {
          state[coreKey] = numValue;
        }
      } else {
        state[coreKey] = param.value;
      }
    });
    return state;
  }
  parseCoreFilter(filterParams) {
    const valueFilterParams = filterParams.filter((p) => p.key.length == 2);
    const rangeFilterParams = filterParams.filter((p) => p.key.length == 3);
    const valueFilters = valueFilterParams.reduce((state, param) => {
      const currentValue = (state.filter || {})[param.key[1]] || [];
      return {
        filter: {
          ...state.filter,
          [param.key[1]]: [...Array.isArray(currentValue) ? currentValue : [currentValue], param.value]
        }
      };
    }, {});
    const rangeFilters = rangeFilterParams.reduce((state, param, index) => {
      let newState = state;
      const nextRangeParam = rangeFilterParams[index + 1];
      if (index % 2 == 0 && nextRangeParam && nextRangeParam.key[1] == param.key[1] && param.key[2] == RangeValueProperties.LOW && nextRangeParam.key[2] == RangeValueProperties.HIGH) {
        const currentValue = (state.filter || {})[param.key[1]] || [];
        newState = {
          filter: {
            ...state.filter,
            [param.key[1]]: [
              ...Array.isArray(currentValue) ? currentValue : [currentValue],
              {
                [RangeValueProperties.LOW]: isNaN(+param.value) ? null : +param.value,
                [RangeValueProperties.HIGH]: isNaN(+nextRangeParam.value) ? null : +nextRangeParam.value
              }
            ]
          }
        };
      }
      return newState;
    }, {});
    return {
      ...valueFilters.filter || rangeFilters.filter ? {
        filter: {
          ...valueFilters.filter,
          ...rangeFilters.filter
        }
      } : {}
    };
  }
  parseCoreSort(sortParams) {
    if (!sortParams.length) {
      return {};
    }
    return {
      sort: sortParams.map((param) => ({
        field: param.key[1],
        direction: param.value
      }))
    };
  }
  parseOther(otherParams) {
    const state = {};
    otherParams.forEach((param) => {
      let node = state;
      param.key.forEach((key, i) => {
        const isLast = i == param.key.length - 1;
        if (isLast) {
          node[key] = node[key] || [];
          param.value && node[key].push(param.value);
        } else {
          node[key] = node[key] || {};
          node = node[key];
        }
      });
    });
    return state;
  }
  serialize(state) {
    const root = this.config.urlRoot.includes("?") ? this.config.urlRoot.split("?")[0] : this.config.urlRoot.includes("#") ? this.config.urlRoot.split("#")[0] : this.config.urlRoot || window.location.pathname;
    const params = this.stateToParams(state);
    const queryParams = params.filter((p) => p.type == ParamLocationType.query);
    const hashParams = params.filter((p) => p.type == ParamLocationType.hash);
    const queryParamString = queryParams.length ? "?" + queryParams.map((param) => {
      const keyString = encodeURIComponent(param.key.join("."));
      const valueString = param.value ? "=" + encodeURIComponent(param.value) : "";
      return keyString + valueString;
    }).join("&") : "";
    const hashParamString = hashParams.length ? "#/" + hashParams.map((param) => {
      const keyString = param.key.map((k) => encodeHashComponent(k)).join(":");
      const valueString = param.value ? ":" + encodeHashComponent(param.value) : "";
      return keyString + valueString;
    }).join("/") : "";
    return `${root}${queryParamString}${hashParamString}`;
  }
  // encode state into params
  stateToParams(state) {
    return [
      ...this.encodeOther(state),
      ...this.encodeCoreOther(state, ["filter", "sort"]),
      ...this.encodeCoreFilters(state),
      ...this.encodeCoreSorts(state)
    ];
  }
  encodeCoreFilters(state) {
    const filterConfig = this.config.parameters.core.filter;
    if (!state.filter || !filterConfig) {
      return [];
    }
    return Object.keys(state.filter).flatMap((key) => {
      if (!state.filter || !state.filter[key]) {
        return [];
      }
      const filter = state.filter[key];
      return (filter instanceof Array ? filter : [filter]).flatMap((value) => {
        if (typeof value == "string" || typeof value == "number" || typeof value == "boolean") {
          return [
            {
              key: [filterConfig.name, key],
              value: "" + value,
              type: filterConfig.type
            }
          ];
        } else if (typeof value == "object" && typeof value[RangeValueProperties.LOW] != "undefined" && typeof value[RangeValueProperties.HIGH] != "undefined") {
          if (filterConfig.type == ParamLocationType.query) {
            return [
              {
                key: [filterConfig.name, key, RangeValueProperties.LOW],
                value: "" + (value[RangeValueProperties.LOW] ?? "*"),
                type: filterConfig.type
              },
              {
                key: [filterConfig.name, key, RangeValueProperties.HIGH],
                value: "" + (value[RangeValueProperties.HIGH] ?? "*"),
                type: filterConfig.type
              }
            ];
          } else if (filterConfig.type == ParamLocationType.hash) {
            return [
              {
                key: [filterConfig.name, key, "" + (value[RangeValueProperties.LOW] ?? "*")],
                value: "" + (value[RangeValueProperties.HIGH] ?? "*"),
                type: filterConfig.type
              }
            ];
          }
        }
        return [];
      });
    });
  }
  encodeCoreSorts(state) {
    const sortConfig = this.config.parameters.core.sort;
    if (!state.sort || !sortConfig) {
      return [];
    }
    return (state.sort instanceof Array ? state.sort : [state.sort]).map((sort) => {
      return {
        key: [sortConfig.name, sort.field],
        value: sort.direction,
        type: sortConfig.type
      };
    });
  }
  encodeCoreOther(state, except) {
    const params = [];
    Object.keys(state).sort(function(a, b) {
      return CORE_FIELDS.indexOf(a) - CORE_FIELDS.indexOf(b);
    }).map((param) => {
      if (CORE_FIELDS.includes(param) && !except.includes(param)) {
        const paramConfig = this.config.parameters.core[param];
        if (param == "page" && state[param] == 1) {
        } else {
          params.push({ key: [paramConfig.name], value: "" + state[param], type: paramConfig.type });
        }
      }
    });
    return params;
  }
  encodeOther(state) {
    let params = [];
    const addRecursive = (obj, currentPath) => {
      Object.keys(obj).forEach((key) => {
        if (currentPath.length == 0 && CORE_FIELDS.includes(key)) {
          return;
        }
        const value = obj[key];
        if (value instanceof Array) {
          const customConfig = this.config.parameters.custom[currentPath[0] || key];
          const type = customConfig?.type || this.config.settings.customType;
          if (value.length) {
            params = params.concat(value.map((v) => {
              return { key: [...currentPath, key], value: v, type };
            }));
          } else {
            params = params.concat({ key: [...currentPath, key], value: "", type });
          }
        } else if (typeof value == "object" && Object.keys(value || {}).length) {
          addRecursive(value, [...currentPath, key]);
        } else {
          const customConfig = this.config.parameters.custom[currentPath[0] || key];
          const type = customConfig?.type || this.config.settings.customType;
          const stringValue = typeof value == "object" ? void 0 : value;
          params = params.concat([{ key: [...currentPath, key], value: stringValue, type }]);
        }
      });
    };
    addRecursive(state, []);
    return params;
  }
  go(url, config) {
    const currentUrl = this.getCurrentUrl();
    if (url != currentUrl) {
      if (config?.history == "replace") {
        history.replaceState(null, "", url);
      } else {
        history.pushState(null, "", url);
      }
    }
  }
};
function decodeHashComponent(string) {
  if (typeof string == "string") {
    string = string.replace(/%2425/g, "$$25");
    string = string.replace(/\$25/g, "%");
    string = decodeURIComponent(string);
  }
  return string;
}
function encodeHashComponent(string) {
  if (typeof string == "string") {
    string = encodeURIComponent(string);
    string = string.replace(/%/g, "$$25");
  }
  return string;
}

// node_modules/@searchspring/snap-url-manager/dist/esm/linkers/react/react.js
function reactLinker(urlManager) {
  return {
    href: urlManager.href,
    onClick: (ev) => {
      if (!urlManager?.detached) {
        ev?.preventDefault();
      }
      urlManager.go();
    }
  };
}

// node_modules/@searchspring/snap-event-manager/dist/esm/MiddlewareManager.js
var MiddlewareManager = class {
  constructor() {
    this.functions = [];
  }
  use(...func) {
    this.functions.push(...func);
  }
  remove(func) {
    const stringyFunc = func.toString();
    this.functions = this.functions.filter((fn) => {
      return func.name !== fn.name || fn.toString() != stringyFunc;
    });
  }
  clear() {
    this.functions = [];
  }
  async dispatch(context) {
    const cancelling = await runFunctionsWithAbortWrapper(context || {}, this.functions);
    if (cancelling == true) {
      throw new Error("cancelled");
    }
  }
};
async function runFunctionsWithAbortWrapper(context, functions) {
  let cancelled = false;
  await runFunctions(context, functions, (proceed) => {
    if (proceed === false)
      cancelled = true;
  });
  return cancelled;
}
async function runFunctions(context, functions, callback) {
  if (!functions.length) {
    return;
  }
  const func = functions[0];
  const proceed = await func(context, async () => {
    await runFunctions(context, functions.slice(1), callback);
  });
  callback(proceed);
}

// node_modules/@searchspring/snap-event-manager/dist/esm/EventManager.js
var EventManager = class {
  constructor() {
    this.events = {};
  }
  async fire(event, context) {
    if (this.events[event]) {
      await this.events[event].dispatch(context);
    }
    return Promise.resolve();
  }
  on(event, ...func) {
    if (!this.events[event]) {
      this.events[event] = new MiddlewareManager();
    }
    this.events[event].use(...func);
  }
};

// node_modules/@searchspring/snap-profiler/dist/esm/Profiler.js
var Profiler = class {
  constructor(namespace) {
    this.namespace = namespace || "";
    this.profiles = [];
  }
  setNamespace(namespace) {
    if (!this.namespace) {
      this.namespace = namespace;
    }
  }
  create({ type, name, context }) {
    if (!name) {
      throw new Error("Profile name is required.");
    }
    const profile = new Profile(this.namespace, { type, name, context });
    this.profiles.push(profile);
    return profile;
  }
};
var Profile = class {
  constructor(namespace, { type, name, context }) {
    this.status = "pending";
    this.time = {
      date: 0,
      begin: 0,
      end: 0,
      run: 0
    };
    this.namespace = namespace;
    this.type = type;
    this.name = name;
    this.context = context;
  }
  start() {
    if (!this.time.begin) {
      this.time.date = Date.now();
      this.time.begin = window.performance.now();
      this.status = "started";
    }
    return this;
  }
  stop() {
    if (!this.time.end && this.time.begin) {
      this.time.date = Date.now();
      this.time.end = window.performance.now();
      this.time.run = +(this.time.end - this.time.begin).toFixed(3);
      this.status = "finished";
    }
    return this;
  }
};

export {
  ControllerTypes,
  FinderController,
  SearchController,
  AutocompleteController,
  RecommendationController,
  UrlManager,
  UrlTranslator,
  reactLinker,
  EventManager,
  Profiler
};
/*! Bundled license information:

css.escape/css.escape.js:
  (*! https://mths.be/cssescape v1.5.1 by @mathias | MIT license *)
*/
